/**
 * VistoeraTASK-00580 — shared Asset Center creator-filter helpers.
 *
 * Candidates come from the server's view-scoped `creator_options` (real
 * created_by_user_id of assets the viewer may see), never the full Workspace
 * membership roster.
 */

export type CreatorOption = {
  user_id: string
  display_name: string
  is_me?: boolean
}

export function buildCreatorSelectOptions(
  labelPrefix: string,
  allLabel: string,
  meLabel: string,
  options: CreatorOption[] | undefined,
  currentUserId: string | undefined,
): Array<{ value: string; label: string }> {
  return [
    { value: 'all', label: `${labelPrefix}: ${allLabel}` },
    { value: 'me', label: `${labelPrefix}: ${meLabel}` },
    ...(options || [])
      .filter((m) => m.user_id !== currentUserId)
      .map((m) => ({
        value: m.user_id,
        label: `${labelPrefix}: ${m.display_name}`,
      })),
  ]
}

/** Entering 我的资产 always clears a leftover creator filter. */
export function creatorFilterAfterViewChange(nextView: string, currentFilter: string): string {
  if (nextView === 'mine') return 'all'
  return currentFilter
}

/**
 * After a shared↔all switch (or a reload), drop a selection that is no longer
 * a valid candidate for the new view.
 */
export function sanitizeCreatorFilter(
  filter: string,
  options: CreatorOption[] | undefined,
): string {
  if (filter === 'all' || filter === 'me') return filter
  if ((options || []).some((o) => o.user_id === filter)) return filter
  return 'all'
}
